import React, { useState, useEffect } from "react";
import Modal from "../../../components/controls/modal/Modal";
import Tabs from "../../../components/controls/tabs/Tabs";
import { useHistory } from "react-router-dom";
import useNavigation from "../../../utils/useNavigation";
import Input from "../../../components/controls/input/customInput/CustomInput";
import OverviewHeader from "../../../components/overviewHeader/OverviewHeader";
import InputUnderline from "../../../components/controls/input/InputUnderline";
import { Tooltip } from "@fluentui/react-components";
import { CalendarIcon } from "../../../modules/default-svg";
import service from "../../../store/services/user.service";
import portfolioService from "../../../store/services/portfolio.service";
import Communication from "../../communication";
import Projects from "../../project/projects";
import {
  dateOnlyFormatted,
  isDateGreaterThan,
  weeksBetweenDates,
} from "../../../utils/systemSettings";
import Details from "../details/details";
import Programs from "../../program/programs";
import Searchable from "../../../components/controls/select/CustomSelect";
import AllocatedResources from "../../allocatedResources";
import ScopeItem from "../../scopeItem";
import ChangeRequest from "../../changeRequest";
import Risk from "../../risk";
import Budget from "../../budget";
import Milestones from "../../milestone";
import { generalActions } from "../../../store/actions";
import DeleteRequest from "../../../components/DeleteRequest/DeleteRequest";
import { useDispatch } from "react-redux";
import deletionRequestService from "../../../store/services/deletionRequest.service";
import RichTextEditor from "../../../components/richTextEditor/RichTextEditor";
import EntityFileUpload from "../../../components/controls/fileUpload/EntityFileUpload";
import { ListChevronsDownUp, ListChevronsUpDown } from "lucide-react";
import Contracts from "../../client/contracts";
import UserSelect from "../../../components/userSelect/UserSelect";
import { UserSearchRefType } from "../../../helpers/utils";
import { SharedTimelineContextProvider } from "../../timeline/SharedTimelineContext";
import Timeline from "../../timeline/timeline";
import { ParentType } from "../../resourcesReport/constants";
import ResourcesReport from "../../resourcesReport/ResourcesReport";

const Overview = (props) => {
  const {
    portfolioID,
    getPortFolioDetails,
    updatePortFolioRequest,
    portfolioData,
    portfolioBudgetSummary,
    portfolioProgressSummary,
    Loading,
    portfolioLoading,
    deleteRequest,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [name, setName] = useState("");
  const [creator, setCreator] = useState({});
  const [clientOwner, setClientOwner] = useState({});
  const [contractStartDate, setContractStartDate] = useState("");
  const [contractEndDate, setContractEndDate] = useState("");
  const [headerTitle, setHeaderTitle] = useState({});
  const [endDate, setEndDate] = useState("");
  const [manager, setManager] = useState(null);
  const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(localStorage.getItem("isOverviewHeaderCollapsed") === "true");

  const history = useHistory();

  const { updateTab, getSelectedTab } = useNavigation();

  const savedTab = getSelectedTab("Portfolios", portfolioID);
  const [selectedNavItem, setSelectedNavItem] = useState(savedTab || "details");

  const handleHeaderSectionState = () => {
    setIsHeaderCollapsed(!isHeaderCollapsed);
    localStorage.setItem("isOverviewHeaderCollapsed", !isHeaderCollapsed);
  }
  // Handle tab change - update both local state and Redux state
  const handleTabChange = (newTab) => {
    setSelectedNavItem(newTab);
    updateTab(newTab);
  };

  // Update tab state when navigation changes (e.g., back/forward navigation)
  useEffect(() => {
    const currentSavedTab = getSelectedTab("Portfolios", portfolioID);
    if (currentSavedTab && currentSavedTab !== selectedNavItem) {
      setSelectedNavItem(currentSavedTab);
    }
  }, [getSelectedTab, portfolioID, selectedNavItem]);
  const [setting] = useState(settings);
  const [riskLevel, setRiskLevel] = useState("");
  const [stakeholder, setStakeholder] = useState("");
  const [objectives, setObjectives] = useState("");
  const [description, setDescription] = useState("");
  const [budget, setBudget] = useState("");
  const [status, setStatus] = useState("");
  const [refId, setRefId] = useState("");
  const [portfolioId, setPortFolioId] = useState("");
  const [client, setClient] = useState("");
  // const [clientId, setClientId] = useState("");
  //
  // const [selectedRow, setSelectedRow] = useState({});
  // const [resources, setResources] = useState([]);
  // const [resourceOptions, setResourceOptions] = useState([]);
  const [startDate, setStartDate] = useState("");
  // const [clientValue, setClientValue] = useState(null);
  const [clients, setClients] = useState([]);
  const [formErrors, setFormErrors] = useState({
    name: "",
    startDate: "",
    endDate: "",
    client,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [attachments, setAttachments] = useState([]);

  const [isPendingDelete, setIsPendingDelete] = useState({});
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [deleteRequestModal, setDeleteRequestModal] = useState(false);
  const [deleteRequestData, setDeleteRequestData] = useState({});
  const [summaryData, setSummaryData] = useState({});
  const [budgetSummary, setBudgetSummary] = useState({
    budget: 0,
    spent: 0,
    actual: 0,
    accural: 0,
    invoiced: 0,
    etc: 0,
    bac: 0,
  });
  const [progressSummary, setProgressSummary] = useState({
    status: 0,
    totalCount: 0,
    progressCount: 0,
    progress: 0,
  });
  const dispatch = useDispatch();

  const handleInputChange = (value, name) => {
    if (name === "startDate") setStartDate(value);
    if (name === "endDate") setEndDate(value);

    if (name === "name") {
      setName(value);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }

    if (name === "client") {
      setClient(value);
      setManager(null);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }
  };

  const overviewHeaderFields = [
    {
      ...creator,
      label: "Created By",
      isResource: true,
    },
    {
      ...manager,
      label: "Portfolio Manager",
      isResource: true,
    },
    {
      label: "Start / End date",
      name: contractStartDate || contractEndDate
        ? `${contractStartDate ? dateOnlyFormatted(setting, contractStartDate) : "-"} to ${contractEndDate ? dateOnlyFormatted(setting, contractEndDate) : "-"}`
        : "-",
      secondary: contractStartDate && contractEndDate
        ? weeksBetweenDates(contractStartDate, contractEndDate)
        : null,
    },
  ];

  const parentData = { id: portfolioID, type: 1 };

  const renderSelectedComponent = () => {
    switch (selectedNavItem) {
      case "details":
        return <Details data={portfolioData} type="Portfolio" isHeaderCollapsed={isHeaderCollapsed} />;
      case "programs":
        return (
          <Programs
            portfolioID={portfolioID}
            defaultClient={{ id: client.value, name: client.label }}
            defaultPortfolio={{
              id: portfolioData.id,
              name: portfolioData.name,
            }}
            overviewType="Portfolio"
          />
        );
      case "projects":
        return (
          <Projects
            portfolioID={portfolioID}
            defaultClient={{ id: client.value, name: client.label }}
            defaultPortfolio={{
              id: portfolioData.id,
              name: portfolioData.name,
            }}
            overviewType="Portfolio"
          />
        );
      case "allocatedResources":
        return <ResourcesReport 
                  parentType={ParentType.PORTFOLIO} 
                  parentId={portfolioID}
                  metaData={{ client: { id: client?.value, name: client?.label } }} />;
      case "scopeItems":
        return (
          <ScopeItem
            portfolioID={portfolioID}
            defaultPortfolio={portfolioData}
            overviewType="Portfolio"
          />
        );
      case "milestones":
        return (
          <Milestones
            parentData={{ id: portfolioData.id, name: portfolioData.name }}
            parentType="Portfolio"
          />
        );
      case "changeRequest":
        return (
          <ChangeRequest
            portfolioID={portfolioID}
            defaultPortfolio={portfolioData}
            overviewType="Portfolio"
          />
        );
      case "risk/Issues":
        return (
          <Risk
            portfolioID={portfolioID}
            defaultPortfolio={portfolioData}
            overviewType="Portfolio"
          />
        );
      case "communication":
        return (
          <Communication
            portfolioID={portfolioID}
            defaultPortfolio={portfolioData}
            overviewType="Portfolio"
          />
        );
      case "budget":
        return (
          <Budget
            portfolioID={portfolioID}
            defaultPortfolio={portfolioData}
            overviewType="Portfolio"
          />
        );
      case "roadmap":
        return (
          <SharedTimelineContextProvider>
            <Timeline
              entityID={portfolioID}
              entityType="portfolio"
              isFullHeight={isHeaderCollapsed}
              setFullHeight={() => { }}
            />
          </SharedTimelineContextProvider>
        );
      default:
        return <Details data={portfolioData} type="Portfolio" isHeaderCollapsed={isHeaderCollapsed} />;
    }
  };

  // const searchHandler = (value) => {
  //   if (value === "") {
  //     setResourceOptions([]);
  //     return;
  //   }
  //   // if (value) {
  //   service
  //     .searchUserDataRequest(value)
  //     .then((res) => {
  //       const transformedArray = res.map((obj) => ({
  //         label: obj.name,
  //         value: obj.id,
  //       }));
  //       setResourceOptions(transformedArray);
  //     })
  //     .catch(() => {});
  //   // }
  // };

  const searchClientHandler = (value) => {
    if (value === "") {
      setClients([]);
      return;
    }
    // if (value) {
    service
      .searchClientDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClients(transformedArray);
      })
      .catch(() => { });
    // }
  };

  const formBody = () => {
    // const { inlineItems, overflowItems } = partitionAvatarGroupItems({
    //   items: assignedResources,
    // });
    return (
      <>
        <InputUnderline
          placeholder="Add portfolio name"
          value={name}
          handleChange={(value) => handleInputChange(value, "name")}
          error={formErrors.name}
          loading={isLoading}
        />
        <div className="d-flex mb-3">
          <div className="mt-4 w-50">
            <Searchable
              label="Client"
              searchText={searchClientHandler}
              isRequired
              SelectText="client"
              options={clients}
              defaultVal={client}
              onChange={(value) => handleInputChange(value, "client")}
              errorMessage={formErrors.client}
              loading={isLoading}
            />
          </div>
        </div>
        <div className="row align-items-start gx-3 mb-3">
          <div className="col-4">
            <UserSelect
              refType={UserSearchRefType.Client}
              refId={client?.value}
              label="Portfolio Manager"
              buttonLabel={"Select Manager"}
              value={manager}
              onChange={setManager}
              loading={isLoading}
              disabled={!client}
            />
          </div>
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={startDate}
              maxDate={endDate}
              type="date"
              handleChange={(value) => handleInputChange(value, "startDate")}
              label="Start Date"
              errorMessage={formErrors.startDate}
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={endDate}
              minDate={startDate}
              type="date"
              handleChange={(value) => handleInputChange(value, "endDate")}
              label="End Date"
              errorMessage={formErrors.endDate}
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              type="number"
              currency={true}
              placeholder="0"
              value={budget}
              handleChange={setBudget}
              label="Budget"
              loading={isLoading}
            />
          </div>
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <Input
              icon={false}
              value={refId}
              type="text"
              placeholder="Enter reference ID"
              handleChange={setRefId}
              label="Reference ID"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter status"
              value={status}
              type="text"
              handleChange={setStatus}
              label="Status"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter risk level"
              value={riskLevel}
              type="text"
              handleChange={setRiskLevel}
              label="Risk level"
              errorMessage={formErrors.riskLevel}
              loading={isLoading}
            />
          </div>
        </div>
        <RichTextEditor
          label="Description"
          content={description}
          onChange={setDescription}
          loading={isLoading}
        />
        <div className="mb-3">
          <RichTextEditor
            label="Stakeholders"
            content={stakeholder}
            onChange={setStakeholder}
            loading={isLoading}
          />
        </div>
        <div className="mb-3">
          <RichTextEditor
            label="Objectives"
            content={objectives}
            onChange={setObjectives}
            loading={isLoading}
          />
        </div>

        <EntityFileUpload
          entityId={portfolioID}
          entityType="Portfolio"
          attachments={attachments}
          onAttachmentsChange={() => {
            // Refresh portfolio data to get updated attachments
            if (portfolioID) {
              portfolioService.getPortfolioDetails({ id: portfolioID })
                .then((portfolioData) => {
                  setAttachments(portfolioData.attachments);
                })
                .catch((error) => {
                  console.error("Error fetching portfolio data:", error);
                });
            }
          }}
          disabled={isLoading || !portfolioID}
        />
      </>
    );
  };

  const showDeleteModal = () => {
    setDeleteModal(true);
  };

  const showEditModal = () => {
    setIsEdit(true);
  };

  useEffect(() => {
    if (portfolioData.hasOwnProperty("name")) {
      setCreator(portfolioData.creator);
      setClientOwner(portfolioData.owner);
      setContractStartDate(portfolioData.startDate);
      setContractEndDate(portfolioData.endDate);
      setHeaderTitle(portfolioData);
      setIsPendingDelete(portfolioData.isPendingDelete);
      portfolioData.client
        ? setClient({
          label: portfolioData.client.name,
          value: portfolioData.client.id,
        })
        : setClient("");

      setBudgetSummary({
        budget: portfolioData.budget,
        spent: portfolioData.spent,
        actual: portfolioData.actual,
        accural: portfolioData.accural,
        invoiced: portfolioData.invoiced,
        etc: portfolioData.etc,
        bac: portfolioData.bac,
      })
      setProgressSummary(portfolioData.progressSummary);
    }
  }, [portfolioData]);

  useEffect(() => {
    if (portfolioBudgetSummary) {
      setBudgetSummary(portfolioBudgetSummary);
    }
  }, [portfolioBudgetSummary]);

  useEffect(() => {
    if (portfolioProgressSummary) {
      setProgressSummary(portfolioProgressSummary);
    }
  }, [portfolioProgressSummary]);

  useEffect(() => {
    fetchPortfolioData();
  }, []);

  const handleSave = () => {
    const errors = {};
    if (!name) errors["name"] = `The Name field is required.`;
    if (startDate && endDate && isDateGreaterThan(startDate, endDate)) {
      errors[
        "endDate"
      ] = `End date must be equal to or greater than start date.`;
    }
    if (!client) errors["client"] = `ClientId is required.`;

    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }

    const payload = {
      Name: name,
      StartDate: startDate || null,
      EndDate: endDate || null,
      Budget: budget ? budget : 0,
      RiskLevel: riskLevel,
      Status: status,
      RefId: refId,
      Description: description,
      ClientId: client && client?.value,
      Stakeholders: stakeholder,
      objectives: objectives,
      OwnerId: manager?.id,
    };


    updatePortFolioRequest({ id: portfolioId, type: "overview", payload });
  };

  const handleCancel = () => {
    setFormErrors({});
    setDeleteModal(false);
    setIsEdit(false);
  };

  useEffect(() => {
    if (!Loading) {
      setIsEdit(false);
    }
  }, [Loading]);

  const handleDelete = () => {
    setIsDeleteLoading(true);
    if (deleteRequest) {
      deletionRequestService
        .confirmDeletionRequest(deleteRequest.requestId)
        .then((response) => {
          setIsDeleteLoading(false);
          setDeleteModal(false);
          history.push(`/portfolio`);
        })
        .catch((err) => {
          dispatch(
            generalActions.showToast({
              title: "Something went wrong. Please try again later.",
              type: "error",
            })
          );
          setIsDeleteLoading(true);
          setDeleteModal(false);
        });
    } else {
      portfolioService
        .deletePortfolioRequest({ id: portfolioID })
        .then((response) => {
          setIsDeleteLoading(false);
          setDeleteModal(false);
          if (response && !response.IsDeletionAllowed) {
            setDeleteRequestData(response);
            setDeleteRequestModal(true);
          } else {
            history.goBack();
          }
        })
        .catch((err) => {
          dispatch(
            generalActions.showToast({
              title: "Something went wrong. Please try again later.",
              type: "error",
            })
          );
          setIsDeleteLoading(true);
          setDeleteModal(false);
        });
    }
  };

  const handleDeleteRequested = () => {
    getPortFolioDetails({ id: portfolioID });
  };

  useEffect(() => {
    getPortFolioDetails({ id: portfolioID });
  }, []);

  const fetchPortfolioData = async () => {
    setIsLoading(true);
    portfolioService
      .getPortfolioDetails({ id: portfolioID })
      .then((portfolio) => {
        // setPortfolioData(portfolio)
        setHeaderTitle(portfolio);
        setName(portfolio.name);
        setBudget(portfolio.budget);
        setStatus(portfolio.status);
        setPortFolioId(portfolio.id);
        setRiskLevel(portfolio.riskLevel);
        setStartDate(portfolio.startDate);
        setEndDate(portfolio.endDate);
        setObjectives(portfolio.objectives);
        setDescription(portfolio.description);
        setStakeholder(portfolio.stakeholders);
        setAttachments(portfolio.attachments || []);
        setRefId(portfolio.refId);
        const clientArray = {
          value: portfolio.client?.id,
          label: portfolio.client?.name,
        };
        setClient(clientArray);
        setManager(portfolio.owner);
        setIsLoading(false);
      })
      .catch((error) => console.error("Error fetching user data:", error));
  };

  useEffect(() => {
    if (isEdit) {
      fetchPortfolioData();
    }
  }, [isEdit]);

  useEffect(() => {
    if (deleteRequest) {
      setDeleteModal(true);
    }
  }, [deleteRequest]);

  return (
    <div className="relative">
      {
        !isHeaderCollapsed &&
        (
          <OverviewHeader
            entityType="portfolio"
            headerTitle={headerTitle}
            headerFields={overviewHeaderFields}
            parentData={parentData}
            showDeleteModal={showDeleteModal}
            showEditModal={showEditModal}
            isShowAction
            loading={portfolioLoading}
            isPendingDelete={isPendingDelete}
            handleRefresh={() => handleDeleteRequested()}
            budgetSummary={budgetSummary}
            progressSummary={progressSummary}
          />
        )
      }

      <div className={isHeaderCollapsed ? "pt-3" : ''}>
        <Tabs
          selectedTab={selectedNavItem}
          setSelectedTab={handleTabChange}
          type="portfolio"
        />
      </div>

      {deleteModal && (
        <Modal
          title={`Delete portfolio`}
          body={
            <p className="text-sm-400 subHeading-color">{`Are you sure you want to delete the portfolio?`}</p>
          }
          handleCancel={() => handleCancel({})}
          handleSave={() => handleDelete()}
          saveBtnLabel="Delete"
          cancelBtnLabel="Cancel"
          isLoading={isDeleteLoading}
        />
      )}
      {deleteRequestModal && (
        <DeleteRequest
          data={deleteRequestData}
          handleCancel={setDeleteRequestModal}
          handleRefresh={() => handleDeleteRequested()}
        />
      )}
      {isEdit && (
        <Modal
          title={`Edit ${portfolioData.name}`}
          handleCancel={() => handleCancel(false)}
          handleSave={() => handleSave()}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          isLoading={Loading}
          size="large"
          body={formBody()}
        />
      )}
      <section
        className="TabsContentSection"
        style={{
          height: `calc(100vh - ${isHeaderCollapsed ? '205' : '400'}px)`,
        }}>
        <div key={selectedNavItem} className="TabsContentFade">
          {renderSelectedComponent()}
        </div>
      </section>
      {!portfolioLoading &&
        (
          <div
            className="absolute top-2 right-2 cursor-pointer opacity-50 hover:opacity-100 hover:text-[#342C82] px-3 py-1 transition-all duration-150 ease-in-out"
            onClick={handleHeaderSectionState}>
            <Tooltip content={isHeaderCollapsed ? "Expand" : "Collapse"} relationship="label" positioning="before">
              {isHeaderCollapsed ? <ListChevronsUpDown size={20} /> : <ListChevronsDownUp size={20} />}
            </Tooltip>
          </div>
        )}
    </div>
  );
};
export default Overview;
